export default __webpack_public_path__ + "static/media/camera.3231cf38.svg";